import { API_endpoints } from "../config";

export const setProfileArchived = async ( id: number | null) => {
    try {
  
        const body = { id };

        const response = await fetch(API_endpoints.setProfileArchived, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            credentials: "include", 
            body: JSON.stringify(body), 
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Laden von Daten.");
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Fehler beim Speichern von Daten:", error);
        throw error;
    }
};
